<div class="flex flex-col gap-4 p-6 max-w-md">
  <h2 class="title-large font-medium text-on-surface m-0">{{ data.titleKey | translate }}</h2>

  <div class="flex flex-col gap-3">
    <p *ngFor="let messageKey of data.messageKeys" class="body-medium text-on-surface-variant m-0">
      {{ messageKey | translate }}
    </p>
  </div>

  <div class="flex justify-end gap-3 mt-2">
    <button mat-stroked-button (click)="cancel()">{{ data.cancelKey | translate }}</button>
    <button mat-flat-button color="primary" (click)="reselect()">{{ data.actionKey | translate }}</button>
  </div>
</div>
